import { ArrowTopRightOnSquareIcon } from '@heroicons/react/24/outline';
import {
  CAREER_SPONSORSHIP_LEAD_TITLE,
  buildCareerSponsorshipDetailRows,
  getCareerSponsorshipPreferencesFromLead,
  isCareerSponsorshipLead,
} from 'lib/career-sponsorship-leads';
import Link from 'next/link';

type CareerSponsorshipLeadDetailsProps = {
  lead: {
    content?: Record<string, any>;
    metadata?: Record<string, any>;
  };
};

export default function CareerSponsorshipLeadDetails({
  lead,
}: CareerSponsorshipLeadDetailsProps) {
  if (!isCareerSponsorshipLead(lead)) {
    return null;
  }

  const preferences = getCareerSponsorshipPreferencesFromLead(lead);
  const rows = buildCareerSponsorshipDetailRows(preferences);
  const sourcePage = preferences?.source_page || '';

  return (
    <div className="sm:col-span-2">
      <dt className="mb-4 text-sm font-medium text-gray-500">
        {CAREER_SPONSORSHIP_LEAD_TITLE}
      </dt>
      <dd className="mt-1 space-y-4">
        {rows.length > 0 ? (
          <div className="rounded-lg border border-teal-200 bg-teal-50 p-4">
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
              {rows.map((row) => (
                <div
                  key={row.label}
                  className={row.multiline ? 'sm:col-span-2' : undefined}
                >
                  <div className="text-xs font-semibold uppercase tracking-wide text-teal-700">
                    {row.label}
                  </div>
                  <div
                    className={`mt-1 text-sm text-gray-900 ${
                      row.multiline ? 'whitespace-pre-wrap' : ''
                    }`}
                  >
                    {row.value}
                  </div>
                </div>
              ))}
            </div>
          </div>
        ) : (
          <p className="text-sm text-gray-700">
            Career sponsorship enquiry with no builder details stored.
          </p>
        )}

        {sourcePage ? (
          <Link
            href={
              sourcePage.startsWith('http')
                ? sourcePage
                : `https://cosmetic.college${sourcePage}`
            }
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center text-sm font-medium text-teal-700 hover:text-teal-800"
          >
            Open career sponsorship page
            <ArrowTopRightOnSquareIcon className="ml-1 h-4 w-4" />
          </Link>
        ) : null}
      </dd>
    </div>
  );
}
